import { Skeleton } from "@nextui-org/react";
import React from "react";

const ToggleSkeleton = ({ length = 2 }) => {
  const array = Array.from(
    { length },
    () => Math.floor(Math.random() * 100) + 1
  );
  return (
    <div className="w-3/6 flex gap-2">
      {array?.map((item, index) => (
        <Skeleton key={index} className="h-11 w-3/5 rounded-full" />
      ))}
    </div>
  );
};

export default ToggleSkeleton;
